export enum FontFamily {
  Inconsolata = 'Inconsolata',
  Sora = 'Sora',
  Sofadi = 'Sofadi One',
  Montserrat = 'Montserrat',
  Bangers = 'Bangers',
}

export enum FontWeight {
  Weight900 = 900,
  Weight200 = 100,
  Weight400 = 500,
}
